import { render, staticRenderFns } from "./modalFoto.vue?vue&type=template&id=10251f83&scoped=true&"
import script from "./modalFoto.vue?vue&type=script&lang=js&"
export * from "./modalFoto.vue?vue&type=script&lang=js&"
import style0 from "./modalFoto.vue?vue&type=style&index=0&id=10251f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10251f83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VIcon,VSpacer,VToolbar})
